import http from '@/http/http'
import apiCfg from "../../config"
export default {
    //查询客户信息
    getUser: function () {
        return http.get("/user");
    },
    //登录
    submitLogin: function (params) {
        return http.post("/login", params);
    },
    //登录
    wxLogin: function (params) {
        return http.get("/wxlogin", params);
    },
    //添加客户的供应商/发货人/进口商
    addUser: function (params) {
        return http.post("/user/userInfo/add", params)
    },
    //查询客户的供应商/发货人/进口商
    queryUser: function (params) {
        return http.get("/user/userInfo/list", params)
    },
    //修改客户的供应商/发货人/进口商
    modifyUser: function (params) {
        return http.post("/user/userInfo/update", params)
    },
    //添加产品
    addProduct: function (params) {
        return http.post("/user/product/add", params)
    },
    //查询产品
    queryProduct: function (params) {
        return http.get("/user/product/list", params)
    },
    //删除产品
    delProduct: function (data, params) {
        return http.post("/user/product/del", data, params)
    },
    //修改产品
    updateProdct: function (params) {
        return http.post("/user/product/update", params)
    },
    //修改客户信息
    updateAccount: function (params) {
        return http.post("/user/update", params)
    },
    //订单分页列表
    orderList: function (params) {
        return http.get("/order/list", params)
    },
    //GET /portal/api/1.0/order/count查询订单数量
    orderListCount: function (params) {
        return http.get("/order/count", params)
    },
    //查询订单详情
    findOrder: function ( params) {
        return http.get('/order/find', params)
    },
    //查询消息
    queryMsg: function (params) {
        return http.get("/user/msg", params)
    },
    //用户余额
    balanceM() {
        return http.get("/user/center/balance")
    },
    //业务统计
    staticsM() {
        return http.get("/user/center/order_statistics")
    },
    //问题件
    abnormal() {
        return http.get("/user/center/abnormal_order_list")
    },
    //文件下载
    orderFile() {
        return http.get("/user/center/order_file_list")
    },
    //用户通知
    logstatus() {
        return http.get("/user/center/order_logstatus_list")
    },
    //查询交易订单
    findList( params) {
        return http.get("/order/transactionRecord/list", params)
    },
    // 查看交易明细
    detailList(params) {
        return http.get("/order/transactionRecord/detail", params)
    },
    //解析excel文件
    parseExcel(params) {
        return http.post("/file/parseExce", params)
    },
    //查询参数GET /manager/api/1.0/sys/param/list
    listParams(params) {
        return http.get( apiCfg.managerApi+ "/sys/param/list",params)
    },
    //查询参数GET /manager/api/1.0/sys/param/list
    listParams2(params) {
        return http.get( apiCfg.managerApi+ "/quote/channel/list",params)
    },
    // 查看送货地
    getPort(params) {
        return http.get("/order/getPort", params)
    },
    //下单
    addOrder(params) {
        return http.post("/order/add", params)
    },
    //取消订单
    cancel(params) {
        return http.post("/order/cancel", params)
    },
    //修改客户密码
    updatePass(params) {
        return http.post("/user/updatePassword", params)
    },
    //删除客户的供应商/发货人/进口商
    updateUser(params) {
        return http.post("/user/userInfo/del", params)
    },
    //快捷登录
    fastLogin(params) {
        return http.post("/fast_login", params)
    },
    //查询公共订单
    search(params){
        return http.get("/searchOrder",params)
    },
    //客户新增收款申请
    submitPayment(params){
        return http.post("/order/submitPayment",params)
    },
    //客户实名认证
    userAuthe(params){
        return http.get("/user/userAuthe",params)
    },
    bindingWeixin(params){
        return http.get("/user/bindingWeixin",params)
    },
    unbindWeixin(params){
        return http.get("/user/unbindWeixin",params)
    },
    addFile(params){
        return http.post( apiCfg.managerApi+ "/report/update",params)
    },
    getTimeData(params){
        return http.get("/order/getTimeData",params)
    },
    selSql(params){
        return http.get( apiCfg.managerApi+ "/report/selSql",params)
    },
    addSql(params){
        return http.get( apiCfg.managerApi+ "/report/addSql",params)
    },
    updateSql(params){
        return http.get( apiCfg.managerApi+ "/report/updateSql",params)
    },
    delSql(params){
        return http.get( apiCfg.managerApi+ "/report/delSql",params)
    },
    setSql(params){
        return http.get( apiCfg.managerApi+ "/report/setSql",params)
    },
    getTracking(params){
        return http.get( apiCfg.managerApi+ "/report/getTracking",params)
    },
}